import { FormEvent, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { AuthSplitLayout } from '../../components/AuthSplitLayout';
import { Button } from '../../components/Button';
import { PasswordInput } from '../../components/PasswordInput';
import { redefinirSenha } from '../../api/auth';

export function RedefinirSenha() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [senha, setSenha] = useState('');
  const [enviando, setEnviando] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setEnviando(true);

    try {
      await redefinirSenha(token, senha);
      await Swal.fire({ icon: 'success', title: 'Senha redefinida com sucesso!', confirmButtonColor: '#1845ba' });
      navigate('/login');
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: 'Não foi possível redefinir a senha',
        text: error.response?.data?.erro || 'O link pode ter expirado.',
        confirmButtonColor: '#1845ba',
      });
    } finally {
      setEnviando(false);
    }
  }

  if (!token) {
    return (
      <AuthSplitLayout titulo="Link inválido">
        <p style={{ fontSize: '14px' }}>Este link de redefinição de senha é inválido ou incompleto.</p>
        <div className="mt-3 text-center" style={{ fontSize: '14px' }}>
          <Link to="/esqueci-senha">Solicitar novo link</Link>
        </div>
      </AuthSplitLayout>
    );
  }

  return (
    <AuthSplitLayout titulo="Criar nova senha">
      <form onSubmit={handleSubmit}>
        <PasswordInput
          label="Nova senha"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
          minLength={8}
          required
        />
        <Button type="submit" disabled={enviando}>
          {enviando ? 'Salvando...' : 'Salvar nova senha'}
        </Button>
      </form>
    </AuthSplitLayout>
  );
}
